module.exports = __webpack_public_path__ + "ajax.worker.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=[name].js!./src/common/ts/ajax.worker.ts
// module id = pTmF
// module chunks = 154